"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { Users, Trophy, User } from "lucide-react";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { translatePosition } from "@/utilities/mappers/squad";
import type { SearchEntity } from "./useSearchPage";
interface EntityResultCardProps {
  entity: SearchEntity;
  href: string | null;
}
export function EntityResultCard(t0) {
  const $ = _c(24);
  const {
    entity,
    href
  } = t0;
  const labels = useLabels();
  const FallbackIcon = entity.entityType === "team" ? Users : entity.entityType === "athlete" ? User : Trophy;
  let t1;
  if ($[0] !== entity.entityType || $[1] !== entity.position || $[2] !== entity.subtitle || $[3] !== labels) {
    t1 = entity.entityType === "athlete" && entity.position ? translatePosition(entity.position, labels.teamPage?.playerPositions) : entity.subtitle;
    $[0] = entity.entityType;
    $[1] = entity.position;
    $[2] = entity.subtitle;
    $[3] = labels;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const displaySubtitle = t1;
  let t2;
  if ($[5] !== FallbackIcon || $[6] !== entity.imageUrl || $[7] !== entity.name) {
    t2 = entity.imageUrl ? <Image src={entity.imageUrl} alt={entity.name} width={56} height={56} className="w-14 h-14 rounded object-contain shrink-0 bg-muted/30 p-1" unoptimized={true} /> : <div className="w-14 h-14 rounded bg-muted/40 shrink-0 flex items-center justify-center"><FallbackIcon className="w-7 h-7 text-muted-foreground" /></div>;
    $[5] = FallbackIcon;
    $[6] = entity.imageUrl;
    $[7] = entity.name;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== entity.name) {
    t3 = <div className="text-sm font-semibold text-foreground line-clamp-2">{entity.name}</div>;
    $[9] = entity.name;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== displaySubtitle) {
    t4 = displaySubtitle && <div className="text-xs text-muted-foreground mt-0.5 truncate">{displaySubtitle}</div>;
    $[11] = displaySubtitle;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <div className="min-w-0 flex-1">{t3}{t4}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t2 || $[17] !== t5) {
    t6 = <div className="flex items-center gap-3 p-3 border border-border rounded-lg bg-card transition hover:bg-muted hover:border-primary/40">{t2}{t5}</div>;
    $[16] = t2;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const inner = t6;
  if (!href) {
    let t7;
    if ($[19] !== inner) {
      t7 = <div className="opacity-60 cursor-default">{inner}</div>;
      $[19] = inner;
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    return t7;
  }
  let t7;
  if ($[21] !== href || $[22] !== inner) {
    t7 = <Link prefetch={false} href={href} className="block">{inner}</Link>;
    $[21] = href;
    $[22] = inner;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}